module.exports = __webpack_public_path__ + "static/media/019.f3013ac3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/019.jpg
// module id = 366
// module chunks = 0